import React from 'react';
import {
  Dialog, DialogTitle, DialogContent,
  Button, Typography, Divider, Alert
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

function AuthGateDialog({ open, onClose, onContinueAsGuest, feature = 'this feature' }) {
  const navigate = useNavigate();

  const handleSignIn = () => {
    onClose();
    navigate('/login');
  };

  const handleCreateAccount = () => {
    onClose();
    navigate('/register');
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Sign in to unlock more</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Create a free account to use {feature} and sync your data across devices.
        </Typography>
        <Button fullWidth variant="contained" onClick={handleCreateAccount} sx={{ mb: 1 }}>
          Create Account
        </Button>
        <Button fullWidth variant="outlined" onClick={handleSignIn} sx={{ mb: 2 }}>
          Sign In
        </Button>
        {onContinueAsGuest && (
          <>
            <Divider sx={{ my: 2 }}>or</Divider>
            <Button fullWidth color="inherit" onClick={onContinueAsGuest}>
              Continue as Guest
            </Button>
            <Alert severity="warning" sx={{ mt: 1 }} variant="outlined">
              Guest favorites are stored in this browser only and will be lost if you clear your data.
            </Alert>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default AuthGateDialog;
